module.exports = __webpack_public_path__ + "static/media/RijbaanA22.79f4fa8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/01/assets/RijbaanA22.jpg
// module id = 347
// module chunks = 0